import { render, staticRenderFns } from "./DialogPromotionLock.vue?vue&type=template&id=c97682ec&scoped=true&lang=pug"
import script from "./DialogPromotionLock.vue?vue&type=script&lang=js"
export * from "./DialogPromotionLock.vue?vue&type=script&lang=js"
import style0 from "./DialogPromotionLock.vue?vue&type=style&index=0&id=c97682ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97682ec",
  null
  
)

export default component.exports